import { Fragment, Dispatch, SetStateAction, MouseEvent } from "react";
import { TableCell, TableRow } from "@mui/material";
import { merge } from "lodash";
import { makeSxStyles } from "ui";
import { GenericTableRow, LabelValueItem } from "./GenericTable";

interface GenericTableRowsProps {
  renderedRows: GenericTableRow[];
  headers: LabelValueItem[];
  // TODO: (RAGIP): Remove any
  onRowClick?: (data: any, e: MouseEvent) => void;
  activeRow: number | null;
  setActiveRow?: Dispatch<SetStateAction<number | null>>;
  draggable: boolean;
}

const GenericTableRows = ({
  renderedRows,
  onRowClick,
  activeRow,
  setActiveRow,
}: GenericTableRowsProps) => {
  const styles = useStyles();
  return renderedRows.map((row, index) => (
    <Fragment key={index}>
      <TableRow
        sx={merge(styles.tableRow, onRowClick ? styles.tableRowClickable : {})}
        key={index}
        hover
        selected={activeRow === index}
        onClick={(e) => {
          onRowClick?.(row.item, e);
          setActiveRow?.(index);
        }}
      >
        {row.values.map(({ label, value, onCellClick, customCSS }) => (
          <TableCell
            key={value}
            component="th"
            scope="row"
            style={customCSS}
            onClick={() => onCellClick?.(value)}
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    </Fragment>
  ));
};

const useStyles = makeSxStyles(({ palette: { grey } }) => ({
  tableRow: {
    height: "70px",
    background: grey["800"],
    ".toShow": {
      display: "none",
    },
    "&:hover": {
      ".toHide": {
        display: "none",
      },
      ".toShow": {
        display: "flex",
      },
    },
    "&:visited": {
      outline: "1px solid #fff",
    },
  },
  tableRowClickable: {
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

export default GenericTableRows;
